export default __webpack_public_path__ + "static/media/houseV2.15b13302.svg";